import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'img-popup',
  templateUrl: './img-popup.component.html',
  styleUrls: ['./img-popup.component.css']
})
export class ImgPopupComponent implements OnInit {

  @Input() photoB64: any;
  @Input() photoB64License: any;

  constructor(
        protected dialogRef: NbDialogRef<ImgPopupComponent>,
        private translate: TranslateService
  ) { }

  ngOnInit(): void {
  }

  closeImg(){
    this.dialogRef.close();
  }

}
